/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 *
 * @author Ilya Babanov
 * @version 1.22.0
 * @since 1.22.0
 */

import type { Dispatch } from 'react';

import { ERequestStatus } from '@/main/types/globalTypes';

import { CreateInquiryModal } from '../../inquiry/components/CreateInquiryModal';
import { ECreateInquiryType } from '../../inquiry/constants';
import Modal from '../../modal/components/Modal';
import { modalOpen } from '../../modal/modalActions';
import { TModalOpenAction } from '../../modal/types/modalActionTypes';
import { EModalStatus } from '../../modal/types/modalTypes';
import { EdmRequestStatusModal } from '../components/EdmRequestStatusModal';

type TOpenEdmInquiry = (
    isInquiriesEnabled: boolean,
    isCoordinator: boolean,
    inquiryTopic: string | undefined,
    dispatch: Dispatch<TModalOpenAction>,
    clientId: string,
    inquiryError: string,
) => void;

export const openEdmInquiry: TOpenEdmInquiry = (
    isInquiriesEnabled,
    isCoordinator,
    inquiryTopic,
    dispatch,
    clientId,
    inquiryError,
) => {
    if (isInquiriesEnabled && isCoordinator) {
        dispatch(
            modalOpen({
                modalParams: {
                    isCustomCrossButton: true,
                },
                render: ({ onCloseModal }) => {
                    return (
                        <CreateInquiryModal
                            id={clientId}
                            initialTopicCode={inquiryTopic}
                            type={ECreateInquiryType.account}
                            onCloseModal={onCloseModal}
                        />
                    );
                },
            }),
        );
    } else {
        dispatch(
            modalOpen({
                modalParams: {
                    isCustomCrossButton: true,
                },
                render: ({ onCloseModal }) => (
                    <Modal dataName="create-inquiry-error-modal" style={{ padding: '24px' }} width="480px">
                        <Modal.Status status={EModalStatus.start}>
                            <EdmRequestStatusModal
                                mode={ERequestStatus.fail}
                                title={inquiryError}
                                onCloseModal={onCloseModal}
                            />
                        </Modal.Status>
                    </Modal>
                ),
            }),
        );
    }
};
